/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

interface LoaderProps {
  blocking?: boolean
  children?: React.ReactNode
  message?: string
}

const Loader: React.FC<LoaderProps> = ({ blocking = false, children, message }) => {
  return (
    <div
      className="loader-container"
      style={{
        position: 'relative',
        minHeight: blocking ? '100px' : undefined
      }}
    >
      {children}
      {blocking && (
        <div
          className="loader-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div className="loader-content">
            <div className="loader-spinner">
              <div
                className="spinner-border"
                role="status"
                style={{
                  width: '3rem',
                  height: '3rem',
                  borderWidth: '0.25rem'
                }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
            {message && (
              <div className="loader-message" style={{ marginTop: '10px' }}>
                {message}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Loader
